import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"


import { Horizontal } from "@/components/Flex.ts"
import { ScrollableModelProvider } from "@/components/Scrollable/ScrollableContextProvider.tsx"
import { ScrollableModelImpl } from "@/components/Scrollable/ScrollableModel.ts"
import { useModel } from "@/hooks/useModel.ts"

import type { ScrollableModel } from "@/components/Scrollable/ScrollableModel.ts"
import type { LinariaClassName } from "@linaria/core"
import type { HTMLAttributes, RefAttributes } from "react"

type ScrollableProps = HTMLAttributes<HTMLDivElement> & RefAttributes<HTMLDivElement> & {
  model?: ScrollableModel,
  childrenContainerClassName?: LinariaClassName
}

export const Scrollable = observer(({ className, ref, ...props }: ScrollableProps) => {
  const model = useModel(() => props.model || new ScrollableModelImpl(), [props.model])

  return (
    <ScrollableModelProvider model={model}>
      <ScrollableRoot className={className} ref={ref}>
        <ScrollableContainer
          ref={model.containerRefCallback}
          showTopShadow={model.hasTopShadow.get()}
          showBottomShadow={model.hasBottomShadow.get()}
        >
          <div className={props.childrenContainerClassName} ref={model.contentRefCallback}>
            {props.children}
          </div>
        </ScrollableContainer>
      </ScrollableRoot>
    </ScrollableModelProvider>
  )
})

const ScrollableRoot = styled(Horizontal)`
  flex: 1;

  position: relative;
  overflow: hidden;
`

export const ScrollableContainer = styled.div<{
  showTopShadow: boolean
  showBottomShadow: boolean
}>`
  flex: 1;
  overflow: auto;
  outline: none;

  mask-image: linear-gradient(
    to bottom,
    transparent 0,
    black ${props => props.showTopShadow ? "24px" : "0"},
    black calc(100% - ${props => props.showBottomShadow ? "24px" : "0.1px"}),
    transparent 100%
  )
`
